export default "__VITE_ASSET__CVUVsIdM__"